import styled from 'styled-components';

export const StyledEmptyValue = styled.div`
  ${({ theme }) => theme.objects.Copy.Subtle}
`;
